import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogBodyProps } from './DialogBody.types';

const MissingTemplateDialogBody = ({ name }: DialogBodyProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t('accessFunction.grid.missingTemplate.message.line1')}
      <br />
      {t('accessFunction.grid.missingTemplate.message.line2', { name })}
    </Fragment>
  );
};

export default MissingTemplateDialogBody;
